import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.PLAN_CREATE_SUCCESS, plan: data.plan });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.PLAN_CREATE_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const planCreate = (data) => {
  return async (dispatch) => {
    dispatch({ type: CONST.PLAN_CREATE_REQUEST });

    axios.post('/plans', data).then((response) => {
      handleResponse(dispatch, response);
    });
  };
};
